export default __webpack_public_path__ + "static/media/Loovers-punti-utente-ambassador.9ebdb975.png";